import { Box, Icon, List, ListItem, Text, Tooltip, TooltipContent } from '@customerio/pluma-components/react';
import { ObjectAttributeTypeLabel } from '../attributes-editor/object-attribute-type-label';
import { CREATED_IN_CIO_AT } from '@/utils/attributes';
import { ObjectAttributeValue } from './object-attribute-value';

type ObjectAttributeListProps = {
  /** Ordered `{ key: value }` pairs, e.g. from `filteredAttrsWithIdentifiers`. */
  attributes: ReadonlyArray<Record<string, string>>;
  isMultiIdentifier: boolean;
  /** Skip the Identifier badge (the identifiers section labels them already). */
  ignoreIdentifiers?: boolean;
};

type ObjectAttributeListItemProps = {
  attributeKey: string;
  value: string;
  isMultiIdentifier: boolean;
  ignoreIdentifiers?: boolean;
};

function ObjectAttributeListItem({ attributeKey, value, ...props }: ObjectAttributeListItemProps) {
  return (
    <ListItem display="flex" alignItems="center" px="300" py="100">
      <Box flex={1}>
        <Box>
          <Text as="span" display="flex" alignItems="center" weight="regular" color="subtle" overflowWrap="words">
            <Text as="span" pr="025" data-test-object-attribute-key>
              {attributeKey}
            </Text>
            {attributeKey === CREATED_IN_CIO_AT ? (
              <Tooltip placement="top" isCustom>
                {(context) => (
                  <>
                    <Icon
                      name="help"
                      size="sm"
                      color="subtle"
                      ref={context.reference.setReference}
                      {...context.reference.getReferenceProps()}
                    />
                    <TooltipContent>Auto-generated by Customer.io.</TooltipContent>
                  </>
                )}
              </Tooltip>
            ) : null}
            <ObjectAttributeTypeLabel
              attribute={attributeKey}
              isMultiIdentifier={props.isMultiIdentifier}
              ignoreIdentifiers={props.ignoreIdentifiers}
            />
          </Text>
        </Box>
        <ObjectAttributeValue value={value} />
      </Box>
    </ListItem>
  );
}

export function ObjectAttributeList({ attributes, isMultiIdentifier, ignoreIdentifiers }: ObjectAttributeListProps) {
  return (
    <List styleType="none" gap="100">
      {attributes.map((attribute) => {
        const [key = ''] = Object.keys(attribute);
        return (
          <ObjectAttributeListItem
            key={key}
            attributeKey={key}
            value={attribute[key] ?? ''}
            isMultiIdentifier={isMultiIdentifier}
            ignoreIdentifiers={ignoreIdentifiers}
          />
        );
      })}
    </List>
  );
}
